<template>
  <div id="body">
    <div class="main_block">
      <template v-if="isWxNavigator"> 
        <div class="main_block_top">
          <img src="../assets/car_icon.png">
          <p>{{code}}</p>
          <div class="main_block_mid">
            <div v-if="plate" class="plate_block">
              <div class="plate_text">{{plate}}</div>
              <div>已安装轮端预警系统</div>
            </div>
            <div v-else class="plate_text" style="background: #B0B2B8">未绑定车辆</div>
          </div>
        </div>
        <!-- env-version="trial" -->
          <!-- :path="sn?'pages/tabBar/home.html?sn='+sn:'pages/tabBar/home.html'" -->
        <div class="main_block_bottom">
          <wx-open-launch-weapp
            class="wx_btn"
            :username="AppletPrimitiveId"
            :path="pageUrl"
            @launch="handleLaunchFn"
            @error="handleErrorFn"
          >
            <script type="text/wxtag-template">
              <style>
                .open{
                  padding: 15px;
                  text-align: center;
                  margin-top: 20px;
                }
                .btn{
                  background-color: #19be6b;
                  color: white;
                  padding: 15px 30px;
                  border: none;
                  border-radius: 5px;
                  font-size: 20px;
                }
              </style>
              <div class="open">
                <button class="btn">小程序关注车况</button>
              </div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </template>
      <template v-if="!isWxNavigator">
        <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
          请使用微信打开
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {getSign,imeiSn} from '../api/api';
export default {
  data() {
    return {
      isWxNavigator: true,
      code: '',
      pageUrl: '',
      hrefUrl: '',
      appLogo: '',
      explainUrl: '',
      downUrl: 'https://cv.e5ex.cn/app/qrCode/iphone.png',
      sn: "",
      AppletPrimitiveId: "",
      notInStorage_code: "",
      AppName: "",
      snCode: "",
      plate: "",
      parentNumber: "",
      isResponse: false
    };
  },
  created() {
    this.checkViewport();
  },
  mounted(){
    this.toMiniapp();
  },
  methods: {
    handleLaunchFn(e) {
      console.log('success', e.detail);
        // window.open("https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzMTE4MDY5MA==#wechat_redirect");
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
    toMiniapp() {
      // document.title = '轮端感知信息牌';
      getSign(window.location.href.split('/#/')[0], window.location.href.split('/#/')[1]).then(({code, msg, data}) => {
        if (!code) {
          this.AppletPrimitiveId = data.AppletPrimitiveId;
          this.AppName = data.AppName;
          this.pageUrl = data.page;
          this.isResponse = true;
          this.appLogo = data.logo;
          // document.title = this.AppName;
          this.plate = data.plate;
          this.parentNumber = data.parentNumber;
          if(data.parentNumber && data.Sn){
            this.$router.push('R'+data.Sn)
          }
          this.snCode = data.Sn;
          wx.config({
            debug: false,
            appId: "wxa897b31443ea9c96",
            signature: data.signature,
            nonceStr: data.nonceStr,
            timestamp: data.timestamp,
            jsApiList: [],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(() => {
            console.log('wx ready')
          });
          wx.error(function (res) {
            console.log("error",res)
          });
          this.notInStorage_code = '';
        } else if (code == -2) {
          // 未入库的设备号
          // this.$message.error(`产品「SN：${data}」未入库，请联系技术支持`);
          this.notInStorage_code = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 查看当前配置
    checkViewport() {
      //判断设备 /R862177043673170
      let path = this.$router.currentRoute.path;
      // this.sn = 'https://e5ex.com/'+window.location.href.split('/#/')[1];
      this.code = window.location.href.split('G')[1];
      let u = navigator.userAgent;
      let platform = navigator.platform;
      if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        this.isWxNavigator = true;
      }else{
        this.isWxNavigator = false;
      }
    }
  }
}
</script>
<style scoped>
.main_block{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 15vw 30px 20vw;
  min-height: 100vh;
  box-sizing: border-box;
}
.main_block_bottom,
.main_block_top{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.main_block_top img{
  height: 60px;
  width: auto;
  margin-bottom: 15px;
}
.main_block_top p{
  color: #808080;
}
.main_block_mid{
  margin-top: 70px;
}
.wx_btn{
  /* width: 190px;
  height: 60px; */
}
.plate_block{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.plate_text{
  padding: 5px 8px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 10px 0 0;
  width: auto;
  background-color: #fec922;
  text-align: center;
  border-radius: 8px;
  margin-bottom: 10px;
}

.btn:active{
  background-color: rgba(25, 190, 107, 0.8);
}

#body {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
}
.button {
  height: 42px;
  width: 85%;
  margin: 0 auto auto;
  font-size: 20px;
  line-height: 40px;
  color: #808080;
}
</style>



// WEBPACK FOOTER //
// src/components/trailerInfoCard.vue